import React from "react"

import { Color } from "@constants/V2/color"
import { getTextColorClass } from "@utils/V2/color"

interface QuotationMarkIconProps {
  fill?: Color
  width?: number
  height?: number
}

const QuotationMarkIcon = ({
  fill = Color.Black,
  width = 32,
  height = 20,
}: QuotationMarkIconProps) => {
  return (
    <div className={getTextColorClass(fill)}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 96 70"
        width={width}
        height={height}
      >
        <path
          fill="currentColor"
          stroke="currentColor"
          d="M21.03 66.89c11.161 0 16.742-4.508 16.742-15.24 0-11.16-3.864-14.166-14.81-14.166-2.361 0-4.293.215-6.225 1.073.859-11.805 6.869-18.459 19.533-23.825L32.406 4C12.659 10.225 3 24.391 3 44.567 3 60.665 8.366 66.89 21.03 66.89Zm54.733 0c11.591 0 16.957-4.508 16.957-15.24 0-11.16-4.078-14.166-15.025-14.166-2.36 0-4.292.215-6.224 1.073.858-11.805 6.868-18.459 19.747-23.825L87.139 4c-19.532 6.225-29.405 20.391-29.405 40.567 0 16.098 5.366 22.323 18.03 22.323Z"
        />
      </svg>
    </div>
  )
}

export default QuotationMarkIcon
